__webpack_require__.p = "/apps/police/battle-awards/";